import React, { useEffect, useState } from "react";
import { Button, Row, Col, Rate, Input } from "antd";
import "./EmpComponent.css";
import { SearchOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import history from "../../../routes/history";
import { getImage } from "../../../utilities/storageOperations/downloadURL";
import deleteicon from "../../../assets/img/deleteicon.png";
import { useDispatch } from "react-redux";
import { deleteEmpAlbums } from "../../../redux/actions";

export default function EmpComponent(props) {

  const dispatch = useDispatch();
  const [imageUrl, setimageUrl] = useState("");

  useEffect(() => {
    getPicture(props.Key);
  }, [props]);

  const getPicture = (Key) => {
    var url = Key;
    if (url !== null) {
      setimageUrl(`${process.env.REACT_APP_S3_URL}/content/pics/albums/${url}`)
    }
  };

  const deleteEmployee = (Key) => {
    dispatch(
      deleteEmpAlbums({
        type: "PEOPL",
        Picture: {
          Filename: Key,
        },
      })
    );
  };
  

  return (
    <div className="EmpComp-div" >
      <div className="pic-div">
        <img src={imageUrl}  className="OurPeople-img" />
      </div>
      <div className="EmpComp-desc"  >
        <div className="EmpComp-txt">{props.Name}</div>
        <div className="EmpComp-txt">{props.Title}</div>
        <div className="EmpComp-txt">{props.Description?.length > 60 ? props.Description?.slice(0,50) + `${"..."}` : props.Description}</div>
        <div style={{justifyContent: "center", alignContent: "center"}}>
          <Row style={{marginTop:'12px'}}>
            <Col span={12}  >
              <button
                className="EmpComp-btn"
                onClick={() =>
                  history.push({
                    pathname: "/companyprofile/addemployee/empdetails",
                    state: {
                      type: "Edit",
                      id: props.id,
                      Key: props.Key,
                      FileSize: props.FileSize,
                      Name: props.Name,
                      Title: props.Title,
                      Description: props.Description,
                      WorkCulture: props.WorkCulture,
                    },
                  })
                }
              >
                Edit bio
              </button>
            </Col>

            <Col
              span={12}
              style={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              <div className="EmpComp-icon-div">
                <div className="EmpComp-icon">
                  <img
                    src={deleteicon}
                    alt="deleteicon"
                    onClick={() => deleteEmployee(props.Key)}
                  ></img>
                </div>
              </div>              
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}
